var _g, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    width: 30,
    height: 30,
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m106.55 203.82 39.86-59.78 9.96 6.65-39.86 59.78-9.96-6.65zm14.95 9.96L161.36 154l9.96 6.65-39.86 59.78-9.96-6.65zm14.95 9.97 39.84-59.79 9.98 6.65-39.86 59.78-9.96-6.64zm189.29 126.21 39.86-59.79 9.96 6.65-39.84 59.77-9.98-6.63zm14.95 9.96 39.85-59.78 9.96 6.64-39.85 59.77-9.96-6.63zm14.95 9.96 39.85-59.78 9.96 6.64-39.85 59.79-9.96-6.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD2E3A",
    d: "M196.23 220.43c22.01-33.02 66.61-41.93 99.63-19.92 33 21.99 41.93 66.62 19.92 99.63l-119.55-79.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047A0",
    d: "M196.23 220.43c-22.01 33.02-13.08 77.62 19.92 99.63 33.01 22.01 77.62 13.08 99.63-19.92 11.01-16.51 6.54-38.82-9.96-49.82s-38.81-6.55-49.82 9.97l-59.77-39.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD2E3A",
    d: "M246.04 210.47c-16.51-11.01-38.81-6.56-49.81 9.96-11.01 16.5-6.56 38.81 9.96 49.82 16.5 11 38.81 6.54 49.81-9.96 11.01-16.52 6.54-38.82-9.96-49.82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.41 376.53-39.86-59.79 9.96-6.64 39.86 59.78-9.96 6.65zm14.95-9.98-39.86-59.77 9.96-6.64 39.86 59.78-9.96 6.63zm14.93-9.96-39.84-59.77 9.96-6.65 39.86 59.79-9.98 6.63zm189.31-126.2-39.86-59.78 9.98-6.65 39.84 59.79-9.96 6.64zm14.94-9.96-39.85-59.78 9.96-6.65 39.85 59.78-9.96 6.65zm14.95-9.96-39.85-59.78 9.96-6.65 39.85 59.78-9.96 6.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m137.29 335.83 14.93-9.96 3.31 4.99-14.95 9.96-3.29-4.99zm201.74-134.48 17.45-11.62 3.31 4.95-17.44 11.62-3.32-4.95zm32.38-21.6 14.95-9.98 3.32 4.99-14.95 9.96-3.32-4.97z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 255,
    fill: "none",
    stroke: "#999999",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKo);
export default __webpack_public_path__ + "static/media/ko.b4a1bd831e08b02f103b08c651849064.svg";
export { ForwardRef as ReactComponent };